import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFileExcel,
  faFilePdf,
  faFileWord,
  faImage,
  faTShirt,
  faUnlock,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
const IconFile = ({type}) => {
  type = type.toUpperCase();
  const icons = {
    PNG: faImage,
    JPG: faImage,
    JPEG: faImage,
    XLSX: faFileExcel,
    PDF: faFilePdf,
    DOC: faFileWord,
    MP4: faVideo,
  };
  return (
    <FontAwesomeIcon
      className="cursor-pointer blue"
      icon={icons[type] ? icons[type] : faUnlock}
    />
  );
};

export default IconFile;
